import {getWebAuthHost} from "@/api/base";


export function toLogin () {
  window.location = `${getWebAuthHost()}/login?app=fugenerator&url=${window.location.href}`
}

export function toSign () {
  window.location = `${getWebAuthHost()}/login?app=fugenerator&sign=1&url=${window.location.href}`
}

// 跳转至个人账号
export function toAccountSettings () {
  window.location = `${getWebAuthHost()}/my/info`
}

// 跳转至FUCyborg
export function toFUCyborg () {
  window.location = `${getWebAuthHost()}/products`
}

// 跳转至个人账号
export function toFabUnion () {
  window.location = `https://www.fab-union.com`
}
